import { APP_INITIALIZER, Provider, inject } from '@angular/core';

import { SessionService } from './session.service';

/**
 * Restores the session from the refresh-token cookie while the app
 * initializes (LEN-2764). The initial navigation, and so every guard, waits
 * for it: after a reload or in a new tab the user is logged in again before
 * `loggedGuard` looks.
 */
export function provideSessionRestore(): Provider {
  return {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: () => {
      const session = inject(SessionService);
      return () => session.restore();
    },
  };
}
